import React from 'react';

const CancelIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.16448 8.0115L15.7403 1.47168C16.0555 1.1596 16.0555 0.654396 15.7403 0.343115C15.4258 0.0310378 14.915 0.0310378 14.6006 0.343115L8.03042 6.87737L1.3995 0.245724C1.08504 -0.0695381 0.574265 -0.0695381 0.259799 0.245724C-0.0546666 0.561782 -0.0546666 1.07335 0.259799 1.38861L6.88587 8.01548L0.235849 14.6287C-0.0786164 14.9408 -0.0786164 15.446 0.235849 15.7573C0.550315 16.0694 1.06109 16.0694 1.37556 15.7573L8.01994 9.14961L14.6244 15.7549C14.9389 16.0702 15.4497 16.0702 15.7641 15.7549C16.0786 15.4389 16.0786 14.9273 15.7641 14.612L9.16448 8.0115Z"
      fill="white"
    />
  </svg>
);

export default CancelIcon;
